import { AppProps } from 'next/app'
import DustinApp from '@dustin-web/microsite-nextjs/src/pages/_app'
import '../components/index.scss'
import devUtils from '../dev-utils.json'

const App = ({ ...props }: AppProps) => {
  return <DustinApp devUtils={devUtils} {...props} />
}

export default App
